import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import {Tesla} from "../../Tesla";
import {TeslaGameAssets} from "../../TeslaGameAssets";
import {TeslaSoundConfig} from "../../TeslaSoundConfig";

/**
 * Created by h3 on 2017-10-26.
 */

export class TeslaFreeSpinPostIntroAnimation extends PIXI.Container {
    private _frameBottomRight:TimelineSprite;
    private _frameLightLeft:TimelineSprite;
    private _frameLightRight:TimelineSprite;
    private _frameLightTop:TimelineSprite;
    private _fsLogoExplosion:TimelineSprite;
    private _fsJoltLogo:TimelineSprite;
    private _fsJoltLogoIdle:TimelineSprite;
    private _frameAll:TimelineSprite;

    private _fsSwitch:TimelineSprite;
    private _idleAnimations:TimelineMax;


    constructor() {
        super();
        this.initAnimations();
    }


    protected initAnimations():void {
        this._frameBottomRight = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.FRAME_BOTTOM_RIGHT));
        this._frameLightLeft = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.FRAME_LEFT));
        this._frameLightRight = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.FRAME_RIGHT));
        this._frameLightTop = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.FRAME_TOP));
        this._frameAll = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.FRAME_ALL));
        this._fsJoltLogo = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.JOLT_LOGO));
        this._fsJoltLogoIdle = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.JOLT_LOGO));

        this._fsLogoExplosion = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.FS_LOGO_EXPLOSION));
        this._fsLogoExplosion.anchor.set(0.5, 0.5);

        this._fsJoltLogo.blendMode = PIXI.BLEND_MODES.ADD;
        this._fsJoltLogoIdle.blendMode = PIXI.BLEND_MODES.ADD;

        this._fsSwitch = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.FS_SWITCH));

        this._frameBottomRight.position.set(567, 422);
        this._frameLightLeft.position.set(-94, 6);
        this._frameLightRight.position.set(672, 0);
        this._frameLightTop.position.set(-97, -96);
        this._frameAll.position.set(-517, -221);
        this._fsJoltLogo.position.set(291, -95);
        this._fsJoltLogoIdle.position.set(291, -95);
        this._fsLogoExplosion.position.set(322, -36);

        this._fsSwitch.position.set(576, 343);

        this.addChild(this._frameBottomRight);
        this.addChild(this._frameLightLeft);
        this.addChild(this._frameLightRight);
        this.addChild(this._frameLightTop);
        this.addChild(this._frameAll);
        this.addChild(this._fsJoltLogo);
        this.addChild(this._fsJoltLogoIdle);
        this.addChild(this._fsLogoExplosion);
        this.addChild(this._fsSwitch);

        this.clearFreespinPostIntroAnimation(false);
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, () => this.endIdleAnimations());
        EventHandler.addEventListener(this, SpinEvent.IDLE, () => this.createIdleAnimations());
    }

    private getElectrifyCableAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_INTRO_CABLE_LIGHTNING),
            this._frameBottomRight.getAnimationAutoShowHide(true, false, [0, 13])
        ]);
        tl.add([
            this._frameLightLeft.getAnimationAutoShowHide(true, false, [0, 12]),
            this._frameLightRight.getAnimationAutoShowHide(true, false, [0, 22])
        ], "-=0.4");
        tl.add([
            this._frameLightTop.getAnimationAutoShowHide(true, false, [0, 13]),
        ], "-=0.4");
        tl.add([
            this._frameLightTop.getAnimationAutoShowHide(true, false, [14, 22]),
            this._fsJoltLogo.getAnimationAutoShowHide(true, false, [0, 7])
        ]);
        tl.add([
            this._fsLogoExplosion.getAnimationAutoShowHide(true, true),
            this._fsJoltLogo.getAnimationAutoShowHide(true, false, [8]),
            () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_INTRO_LOGO_EXPLODE),
            this._frameLightTop.getAnimationAutoShowHide(true, false, [22, 25])
        ]);

        return tl;
    }

    private getCableGlowAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            this._frameBottomRight.getAnimationAutoShowHide(true, false, [13]),
            this._frameLightLeft.getAnimationAutoShowHide(true, false, [12]),
            this._frameLightRight.getAnimationAutoShowHide(true, false, [22]),
            this._frameLightTop.getAnimationAutoShowHide(true, false, [25])
        ]);

        return tl;
    }

    public getFreespinPostIntroAnimation(restoreState:boolean = false):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        this._fsJoltLogo.alpha = 1;
        this._fsJoltLogo.hide();

        if(restoreState) {
            tl.add(() => this._fsSwitch.setFrame(this._fsSwitch.totalFrames - 1));
            tl.add(() => this._frameAll.alpha = 1);

            tl.add([
                this._fsJoltLogo.getAnimationAutoShowHide(true, false, [8]),
                () => this._frameBottomRight.hide(),
                () => this._frameLightLeft.hide(),
                () => this._frameLightRight.hide(),
                () => this._frameLightTop.hide()
            ]);
        } else {
            tl.add([
                this._fsSwitch.getAnimation().timeScale(2),
                () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_INTRO_SWITCH_DOWN)
            ]);
            tl.add(this.getElectrifyCableAnimation());
            tl.add(this.getCableGlowAnimation());
            tl.add(new TweenLite(this._frameAll, 0.333, {alpha : 1}), "-=0.3");

            tl.add([
                () => Tesla.background.getBlinkAnimation(),
                () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.FS_INTRO_COIL_LIGHTNING),
            ]);

            tl.add([
                () => this._frameBottomRight.hide(),
                () => this._frameLightLeft.hide(),
                () => this._frameLightRight.hide(),
                () => this._frameLightTop.hide()
            ]);
        }
        return tl;
    }

    public clearFreespinPostIntroAnimation(animate:boolean = true):void {
        this._fsSwitch.setFrame(0);
        this._frameBottomRight.hide();
        this._frameLightLeft.hide();
        this._frameLightRight.hide();
        this._frameLightTop.hide();
        this._fsJoltLogo.hide();
        this._fsLogoExplosion.hide();
        if(animate) {
            new TweenLite(this._frameAll, 0.333, {alpha : 0});
        } else {
            this._frameAll.alpha = 0;
        }

    }

    private createIdleAnimations() {
        this._idleAnimations = new TimelineMax({repeat : -1, repeatDelay : 6, delay : 12});
        this._fsJoltLogoIdle.alpha = 0;
        this._idleAnimations.add([
            () => SlotGame.sound.playEffect(TeslaSoundConfig.instance.IDLE_JOLT),
            () => this._fsJoltLogoIdle.show(),
            this._fsJoltLogoIdle.getAnimation([7, 7]),
            new TweenLite(this._fsJoltLogoIdle, 0.01, {alpha : 1})
        ]);
        this._idleAnimations.add(new TweenLite(this._fsJoltLogoIdle, 0.01, {alpha : 0.5}), "+= 0.01");
        this._idleAnimations.add(new TweenLite(this._fsJoltLogoIdle, 0.05, {alpha : 1}), "+= 0.05");
        this._idleAnimations.add(new TweenLite(this._fsJoltLogoIdle, 0.05, {alpha : 0}), "+=0.01");
        this._idleAnimations.add(new TweenLite(this._fsJoltLogoIdle, 0.01, {alpha : 1}), "+= 0.17");
        this._idleAnimations.add(new TweenLite(this._fsJoltLogoIdle, 0.07, {alpha : 0}), "+=0.2");
        this._idleAnimations.add(() => this._fsJoltLogoIdle.hide());
    }

    private endIdleAnimations() {
        this._fsJoltLogoIdle.hide();
        if(this._idleAnimations) {
            this._idleAnimations.kill();
        }
    }
}